<template>
	<div :class="disable_when_not_configure">
		<button @click="e => daysSelectorEventHandler( e, 'month' )" class=" days-selector">{{ i18n.__( 'Month', 'post-smtp' ) }}</button>
		<button @click="e => daysSelectorEventHandler( e, 'week' )" class="active days-selector">{{ i18n.__( 'Week', 'post-smtp' ) }}</button>
		<button @click="e => daysSelectorEventHandler( e, 'day' )" class="days-selector">{{ i18n.__( 'Day', 'post-smtp' ) }}</button>
	</div>
</template>

<script>
export default {
	props: {
		postSmtpConfigured: {
			type: Boolean,
			default: false,
		},
	},

	name: 'PostSmtpDaysSelector',
	inject: [ 'i18n' ],

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),

	methods: {
		daysSelectorEventHandler( e, period ) {
			e.preventDefault();

			const buttons = document.querySelectorAll( '.days-selector' );

			buttons.forEach( button => {
				button.classList.remove( 'active' );
			} );

			e.target.classList.add( 'active' );

			this.$emit( 'days-selector-event', period );
		}
	},

	computed: {
		disable_when_not_configure() {
			let classes = {
				'wrapper': true,
			};

			if ( ! this.postSmtpConfigured ) {
				classes['disabled'] = true;
			}


			return classes;
		}
	},
}
</script>

<style scoped>
.wrapper {
	width: 177px;
	height: 32px;
	top: 146px;
	left: 213px;
	border-radius: 16px;
	background: #FFFFFF;
	border: 1px solid #DCDFE5
}

.days-selector {
	margin: 4px 0 0 2px;

	cursor: pointer;

	width: 56px;
	height: 24px;
	display: inline-block;

	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 12px;
	text-align: center;

	color: #44566C;

	border: none;
	outline: none;
	background: none;
}

.days-selector.active {
	border-radius: 12px;
	background: #F3F7FF;
	color: #375CAF;
}

.disabled {
	pointer-events: none;
}

.disabled .days-selector {
	cursor: not-allowed;
}

.disabled .days-selector.active {
	background: none;
	cursor: not-allowed;
	color: #44566C;;
}
</style>